import { useState, CompositionEvent } from 'react';

type rtnType = [boolean, (event: CompositionEvent<HTMLTextAreaElement>) => void];
/**
 * 输入法时输入文字处理.
 * @returns
 *  - isOnIMEComposition: 输入法状态中;
 *  - handleIMEComposition: 输入法状态监控
 *    ```
 *      onCompositionStart={handleIMEComposition}
 *      onCompositionUpdate={handleIMEComposition}
 *      onCompositionEnd={handleIMEComposition}
 *    ```
 */
export default function useIMEComposition(handler: (value: string) => void): rtnType {
  const [isOnIMEComposition, setIsOnIMEComposition] = useState(false);
  const handleIMEComposition = (evt: CompositionEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if (evt.type === 'compositionend') {
      setIsOnIMEComposition(false);
      // @ts-ignore
      handler(evt.target.value);
    } else {
      setIsOnIMEComposition(true);
    }
  };
  return [isOnIMEComposition, handleIMEComposition];
}
